module.exports = function() {
  return new Worker(__webpack_public_path__ + "9cc329b69a5dbad35bf3.worker.js");
};